import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtDate } from "@/lib/api";
import { PageHeader, Empty } from "@/components/Primitives";

const ACTIONS = ["booking_submitted", "booking_updated", "booking_resubmitted", "card_revealed", "payment_charged", "payment_partial",
  "payment_declined", "payment_failed", "agent_notified", "agent_notify_failed", "weekly_digest_run", "booking_voided", "document_uploaded", "document_deleted", "user_created", "user_updated", "merchant_created", "merchant_updated"];

export default function AuditLog() {
  const [f, setF] = useState({ q: "", action: "", from: "", to: "" });
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    const t = setTimeout(() => api.get("/audit", { params }).then((r) => setRows(r.data)), 250);
    return () => clearTimeout(t);
  }, [f]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <div data-testid="audit-page">
      <PageHeader eyebrow="Compliance" title="Audit Logs" />
      <div className="panel p-3 flex flex-wrap gap-2 mb-5">
        <input data-testid="audit-search" className="field w-56" placeholder="Booking ref or user…" value={f.q} onChange={set("q")} />
        <select data-testid="audit-action" className="field w-52" value={f.action} onChange={set("action")}><option value="">All actions</option>{ACTIONS.map((a) => <option key={a} value={a}>{a.replace(/_/g, " ")}</option>)}</select>
        <input data-testid="audit-from" type="date" className="field w-40" value={f.from} onChange={set("from")} />
        <input data-testid="audit-to" type="date" className="field w-40" value={f.to} onChange={set("to")} />
      </div>
      {rows === null ? <div className="text-slate-500">Loading…</div> : !rows.length ? <Empty text="No audit entries match." /> : (
        <div className="panel overflow-x-auto">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-800"><tr><th className="px-4 py-3">When</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Booking</th><th className="px-4 py-3">Actor</th><th className="px-4 py-3">Details</th></tr></thead>
            <tbody>
              {rows.map((a) => (
                <tr key={a.id} className="border-b border-slate-800/70 last:border-0 hover:bg-slate-800/50" data-testid={`audit-row-${a.id}`}>
                  <td className="px-4 py-3 text-xs text-slate-500 whitespace-nowrap">{fmtDate(a.created_at)}</td>
                  <td className="px-4 py-3"><span className={`rounded border px-2 py-0.5 text-[11px] font-semibold ${a.action === "card_revealed" ? "border-amber-500/30 text-amber-300 bg-amber-500/10" : a.action.startsWith("payment_") ? "border-emerald-500/30 text-emerald-300 bg-emerald-500/10" : "border-slate-700 text-slate-300"}`}>{a.action.replace(/_/g, " ")}</span></td>
                  <td className="px-4 py-3">{a.booking_ref ? <Link to={`/bookings/${a.entity_id}`} className="font-mono text-indigo-300 hover:text-indigo-200">{a.booking_ref}</Link> : <span className="text-slate-600">{a.entity_type}</span>}</td>
                  <td className="px-4 py-3">{a.actor_name}<div className="text-xs text-slate-500">{a.actor_role}</div></td>
                  <td className="px-4 py-3 text-xs text-slate-400 font-mono max-w-md truncate">{Object.entries(a.meta || {}).filter(([, v]) => v != null && v !== "").map(([k, v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`).join(" · ") || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
